/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { NbDateService } from '@nebular/theme';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'ngx-footer',
  styleUrls: ['./footer.component.scss'],
  templateUrl: './footer.component.html'
  // template: `
  //   <span class="created-by">Developed with ♥ by <b>
  //     <a href="https://ezovion.com" target="_blank">Ezovion</a></b> {{ currentYear }}</span>
  //   <div class="socials">
  //     <a href="https://www.youtube.com/ezovion" target="_blank" class="ion ion-social-youtube"></a>
  //     <a href="https://www.facebook.com/ezovion" target="_blank" class="ion ion-social-facebook"></a>
  //     <a href="https://twitter.com/ezovion" target="_blank" class="ion ion-social-twitter"></a>
  //     <a href="https://www.linkedin.com/company/35907021/" target="_blank" class="ion ion-social-linkedin"></a>
  //   </div>
  // `,
})
export class FooterComponent {
  dayDifference: number;
  passwordExpiredDays = environment.passwordExpiredDays;
  resetPasswordExpiredDays = environment.ResetpasswordNotificationDays;
  public resetDateFromLocalStorage = localStorage.getItem("passwordResetDate");
  get currentYear(): number {
    return new Date().getFullYear();
  }
  constructor(private dateServices: NbDateService<Date>, protected router: Router) {

  }
  ngOnInit() {
    var footerId = document.getElementById("foot-id");
    if (this.resetDateFromLocalStorage != "null") {
      var currentDate = new Date();
      var resetDate = new Date(this.resetDateFromLocalStorage);
      var pwdExpireDate = this.dateServices.addDay(resetDate, this.passwordExpiredDays);
      let time = pwdExpireDate.getTime() - currentDate.getTime();
      this.dayDifference =Math.round( time / (1000 * 3600 * 24));
      if (this.dayDifference >= 0 && this.dayDifference <= this.resetPasswordExpiredDays)
        footerId.style.display = "block";
        else if(this.dayDifference < 0)
        footerId.style.display = "block";
      else footerId.style.display = "none";
    }}
    changePwd()
    {
      this.router.navigateByUrl("pages/auth/reset-pwd-inside-app")
    }
    later(){
      var footerId = document.getElementById("foot-id");
      footerId.style.display = "none";
    }
}
